import React, { createContext, ReactNode, useContext } from "react";
import {
  IAccountService,
  IPropertySelection,
  IUserContext,
  TOPICS,
} from "@origin-digital/event-dispatcher";
import { useRespondWhenDefined } from "../hooks/useRespondWhenDefined";
import { useAutoRefreshingData } from "../hooks/useAutoRefreshingData";
import { usePropertySelection } from "../hooks/usePropertySelection";
import { fetchUserContextV3 } from "./UserContextService";

export type UserContextType = {
  user?: IUserContext;
  loading: boolean;
  properties?: IPropertySelection[];
  property: IPropertySelection | null;
  setProperty: (property: IPropertySelection | null) => void;
  setService: (accountService: IAccountService) => void;
};

export const UserContext = createContext<UserContextType>({
  user: undefined,
  loading: true,
  properties: undefined,
  property: null,
  setProperty: () => {},
  setService: () => {},
});

export const useUserContext = () => useContext(UserContext);

export const UserContextProvider = ({ children }: { children: ReactNode }) => {
  const { data: user, loading } = useAutoRefreshingData<
    IUserContext | undefined
  >(fetchUserContextV3);
  useRespondWhenDefined(TOPICS.FETCH_USER_CONTEXT, user);

  const { properties, property, setProperty, setService } =
    usePropertySelection(user);
  useRespondWhenDefined(TOPICS.FETCH_ALL_PROPERTIES, properties);

  return (
    <UserContext.Provider
      value={{
        user,
        loading,
        properties,
        property,
        setProperty,
        setService,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
